// extracted by mini-css-extract-plugin
export default {"products":"yA-z","card":"zA-z","oosMessaging":"AA-z"};